/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateExamDto
 */
export interface CreateUpdateExamDto {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateExamDto
     */
    number?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    examinedId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    psychologistUID?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamDto
     */
    registrationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateExamDto
     */
    articlePsychologistsIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateExamDto
     */
    articleDoctorsIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    drivingLicense?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateExamDto
     */
    occupationalMedicineCategory?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    occupationalMedicineText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    type?: CreateUpdateExamDtoTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamDto
     */
    referralDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    employerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    employerAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    employmentPosition?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    employmentCandidate?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    employeePeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    sportsClubName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    sportsClubAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    sportsDiscipline?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamDto
     */
    lossOfAbilityDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    kindOfScience?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamDto
     */
    endScience?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    schoolName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    schoolAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    fieldOfStudy?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    schoolCandidate?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    schoolPeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    takenCareOf?: CreateUpdateExamDtoTakenCareOfEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    referralFromEmployer?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    areHarmfulFactors?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    areResultsHarmfulFactors?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateExamDto
     */
    harmfulFactorsIds?: Array<string> | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    completed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    neurologist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    ophthalmologist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    laryngologist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    psychologistConsultation?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    psychiatrist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    ophthalmologistEnded?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    laryngologistEnded?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    neurologistEnded?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    psychiatristEnded?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    batteryId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    healthcare?: CreateUpdateExamDtoHealthcareEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    examPackageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    external?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    whoExamined?: CreateUpdateExamDtoWhoExaminedEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    alarm?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    online?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    remote?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamDto
     */
    inFacility?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    paid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    paymentType?: CreateUpdateExamDtoPaymentTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamDto
     */
    sellDocumentType?: CreateUpdateExamDtoSellDocumentTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamDto
     */
    paymentDate?: Date | null;
}


/**
 * @export
 */
export const CreateUpdateExamDtoTypeEnum = {
    Initial: 'Initial',
    Periodic: 'Periodic',
    Control: 'Control',
    PeriodicControl: 'PeriodicControl'
} as const;
export type CreateUpdateExamDtoTypeEnum = typeof CreateUpdateExamDtoTypeEnum[keyof typeof CreateUpdateExamDtoTypeEnum];

/**
 * @export
 */
export const CreateUpdateExamDtoTakenCareOfEnum = {
    Employee: 'Employee',
    Outwork: 'Outwork',
    Student: 'Student',
    OwnRequest: 'OwnRequest'
} as const;
export type CreateUpdateExamDtoTakenCareOfEnum = typeof CreateUpdateExamDtoTakenCareOfEnum[keyof typeof CreateUpdateExamDtoTakenCareOfEnum];

/**
 * @export
 */
export const CreateUpdateExamDtoHealthcareEnum = {
    Doctor: 'Doctor',
    Dentist: 'Dentist',
    Midwife: 'Midwife',
    Nurse: 'Nurse'
} as const;
export type CreateUpdateExamDtoHealthcareEnum = typeof CreateUpdateExamDtoHealthcareEnum[keyof typeof CreateUpdateExamDtoHealthcareEnum];

/**
 * @export
 */
export const CreateUpdateExamDtoWhoExaminedEnum = {
    Student: 'Student',
    Employee: 'Employee',
    Sanitary: 'Sanitary',
    EmployeeAndSanitary: 'EmployeeAndSanitary',
    StudentAndSanitary: 'StudentAndSanitary',
    SanitaryStudent: 'SanitaryStudent'
} as const;
export type CreateUpdateExamDtoWhoExaminedEnum = typeof CreateUpdateExamDtoWhoExaminedEnum[keyof typeof CreateUpdateExamDtoWhoExaminedEnum];

/**
 * @export
 */
export const CreateUpdateExamDtoPaymentTypeEnum = {
    Gotwka: 'Gotówka',
    Karta: 'Karta',
    Przelew: 'Przelew',
    Patno_mobilna: 'Płatność mobilna'
} as const;
export type CreateUpdateExamDtoPaymentTypeEnum = typeof CreateUpdateExamDtoPaymentTypeEnum[keyof typeof CreateUpdateExamDtoPaymentTypeEnum];

/**
 * @export
 */
export const CreateUpdateExamDtoSellDocumentTypeEnum = {
    Paragon: 'Paragon',
    Faktura: 'Faktura'
} as const;
export type CreateUpdateExamDtoSellDocumentTypeEnum = typeof CreateUpdateExamDtoSellDocumentTypeEnum[keyof typeof CreateUpdateExamDtoSellDocumentTypeEnum];


/**
 * Check if a given object implements the CreateUpdateExamDto interface.
 */
export function instanceOfCreateUpdateExamDto(value: object): value is CreateUpdateExamDto {
    return true;
}

export function CreateUpdateExamDtoFromJSON(json: any): CreateUpdateExamDto {
    return CreateUpdateExamDtoFromJSONTyped(json, false);
}

export function CreateUpdateExamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateExamDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'examinedId': json['examinedId'] == null ? undefined : json['examinedId'],
        'psychologistUID': json['psychologistUID'] == null ? undefined : json['psychologistUID'],
        'registrationDate': json['registrationDate'] == null ? undefined : (new Date(json['registrationDate'])),
        'description': json['description'] == null ? undefined : json['description'],
        'articlePsychologistsIds': json['articlePsychologistsIds'] == null ? undefined : json['articlePsychologistsIds'],
        'articleDoctorsIds': json['articleDoctorsIds'] == null ? undefined : json['articleDoctorsIds'],
        'drivingLicense': json['drivingLicense'] == null ? undefined : json['drivingLicense'],
        'occupationalMedicineCategory': json['occupationalMedicineCategory'] == null ? undefined : json['occupationalMedicineCategory'],
        'occupationalMedicineText': json['occupationalMedicineText'] == null ? undefined : json['occupationalMedicineText'],
        'type': json['type'] == null ? undefined : json['type'],
        'referralDate': json['referralDate'] == null ? undefined : (new Date(json['referralDate'])),
        'employerName': json['employerName'] == null ? undefined : json['employerName'],
        'employerAddress': json['employerAddress'] == null ? undefined : json['employerAddress'],
        'employmentPosition': json['employmentPosition'] == null ? undefined : json['employmentPosition'],
        'employmentCandidate': json['employmentCandidate'] == null ? undefined : json['employmentCandidate'],
        'employeePeriod': json['employeePeriod'] == null ? undefined : json['employeePeriod'],
        'sportsClubName': json['sportsClubName'] == null ? undefined : json['sportsClubName'],
        'sportsClubAddress': json['sportsClubAddress'] == null ? undefined : json['sportsClubAddress'],
        'sportsDiscipline': json['sportsDiscipline'] == null ? undefined : json['sportsDiscipline'],
        'lossOfAbilityDate': json['lossOfAbilityDate'] == null ? undefined : (new Date(json['lossOfAbilityDate'])),
        'kindOfScience': json['kindOfScience'] == null ? undefined : json['kindOfScience'],
        'endScience': json['endScience'] == null ? undefined : (new Date(json['endScience'])),
        'schoolName': json['schoolName'] == null ? undefined : json['schoolName'],
        'schoolAddress': json['schoolAddress'] == null ? undefined : json['schoolAddress'],
        'fieldOfStudy': json['fieldOfStudy'] == null ? undefined : json['fieldOfStudy'],
        'schoolCandidate': json['schoolCandidate'] == null ? undefined : json['schoolCandidate'],
        'schoolPeriod': json['schoolPeriod'] == null ? undefined : json['schoolPeriod'],
        'takenCareOf': json['takenCareOf'] == null ? undefined : json['takenCareOf'],
        'referralFromEmployer': json['referralFromEmployer'] == null ? undefined : json['referralFromEmployer'],
        'areHarmfulFactors': json['areHarmfulFactors'] == null ? undefined : json['areHarmfulFactors'],
        'areResultsHarmfulFactors': json['areResultsHarmfulFactors'] == null ? undefined : json['areResultsHarmfulFactors'],
        'harmfulFactorsIds': json['harmfulFactorsIds'] == null ? undefined : json['harmfulFactorsIds'],
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'completed': json['completed'] == null ? undefined : json['completed'],
        'neurologist': json['neurologist'] == null ? undefined : json['neurologist'],
        'ophthalmologist': json['ophthalmologist'] == null ? undefined : json['ophthalmologist'],
        'laryngologist': json['laryngologist'] == null ? undefined : json['laryngologist'],
        'psychologistConsultation': json['psychologistConsultation'] == null ? undefined : json['psychologistConsultation'],
        'psychiatrist': json['psychiatrist'] == null ? undefined : json['psychiatrist'],
        'ophthalmologistEnded': json['ophthalmologistEnded'] == null ? undefined : json['ophthalmologistEnded'],
        'laryngologistEnded': json['laryngologistEnded'] == null ? undefined : json['laryngologistEnded'],
        'neurologistEnded': json['neurologistEnded'] == null ? undefined : json['neurologistEnded'],
        'psychiatristEnded': json['psychiatristEnded'] == null ? undefined : json['psychiatristEnded'],
        'batteryId': json['batteryId'] == null ? undefined : json['batteryId'],
        'healthcare': json['healthcare'] == null ? undefined : json['healthcare'],
        'examPackageId': json['examPackageId'] == null ? undefined : json['examPackageId'],
        'external': json['external'] == null ? undefined : json['external'],
        'whoExamined': json['whoExamined'] == null ? undefined : json['whoExamined'],
        'alarm': json['alarm'] == null ? undefined : json['alarm'],
        'online': json['online'] == null ? undefined : json['online'],
        'remote': json['remote'] == null ? undefined : json['remote'],
        'inFacility': json['inFacility'] == null ? undefined : json['inFacility'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
        'sellDocumentType': json['sellDocumentType'] == null ? undefined : json['sellDocumentType'],
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
    };
}

export function CreateUpdateExamDtoToJSON(value?: CreateUpdateExamDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'number': value['number'],
        'examinedId': value['examinedId'],
        'psychologistUID': value['psychologistUID'],
        'registrationDate': value['registrationDate'] == null ? undefined : ((value['registrationDate'] as any).toISOString()),
        'description': value['description'],
        'articlePsychologistsIds': value['articlePsychologistsIds'],
        'articleDoctorsIds': value['articleDoctorsIds'],
        'drivingLicense': value['drivingLicense'],
        'occupationalMedicineCategory': value['occupationalMedicineCategory'],
        'occupationalMedicineText': value['occupationalMedicineText'],
        'type': value['type'],
        'referralDate': value['referralDate'] == null ? undefined : ((value['referralDate'] as any).toISOString()),
        'employerName': value['employerName'],
        'employerAddress': value['employerAddress'],
        'employmentPosition': value['employmentPosition'],
        'employmentCandidate': value['employmentCandidate'],
        'employeePeriod': value['employeePeriod'],
        'sportsClubName': value['sportsClubName'],
        'sportsClubAddress': value['sportsClubAddress'],
        'sportsDiscipline': value['sportsDiscipline'],
        'lossOfAbilityDate': value['lossOfAbilityDate'] == null ? undefined : ((value['lossOfAbilityDate'] as any).toISOString()),
        'kindOfScience': value['kindOfScience'],
        'endScience': value['endScience'] == null ? undefined : ((value['endScience'] as any).toISOString()),
        'schoolName': value['schoolName'],
        'schoolAddress': value['schoolAddress'],
        'fieldOfStudy': value['fieldOfStudy'],
        'schoolCandidate': value['schoolCandidate'],
        'schoolPeriod': value['schoolPeriod'],
        'takenCareOf': value['takenCareOf'],
        'referralFromEmployer': value['referralFromEmployer'],
        'areHarmfulFactors': value['areHarmfulFactors'],
        'areResultsHarmfulFactors': value['areResultsHarmfulFactors'],
        'harmfulFactorsIds': value['harmfulFactorsIds'],
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'completed': value['completed'],
        'neurologist': value['neurologist'],
        'ophthalmologist': value['ophthalmologist'],
        'laryngologist': value['laryngologist'],
        'psychologistConsultation': value['psychologistConsultation'],
        'psychiatrist': value['psychiatrist'],
        'ophthalmologistEnded': value['ophthalmologistEnded'],
        'laryngologistEnded': value['laryngologistEnded'],
        'neurologistEnded': value['neurologistEnded'],
        'psychiatristEnded': value['psychiatristEnded'],
        'batteryId': value['batteryId'],
        'healthcare': value['healthcare'],
        'examPackageId': value['examPackageId'],
        'external': value['external'],
        'whoExamined': value['whoExamined'],
        'alarm': value['alarm'],
        'online': value['online'],
        'remote': value['remote'],
        'inFacility': value['inFacility'],
        'paid': value['paid'],
        'paymentType': value['paymentType'],
        'sellDocumentType': value['sellDocumentType'],
        'paymentDate': value['paymentDate'] == null ? undefined : ((value['paymentDate'] as any).toISOString()),
    };
}

